'use strict';

const { bindGA, getText } = require('./util/analytics-util');
const { queryAll, queryFirst } = require('lilly/domUtil');
const { GET_DIRECTIONS, STORE_INTERACTION } = require('./util/constants');

const STORE_SELECTIONS = 'store selections';
const FIND_A_STORE = 'find a store';
const MAP_CLICK = 'map click';
const SEARCH_STORE_SUBMISSION = 'search store submission';

/**
 * Analytics for Store Locator
 */
function initEvents() {
    const { body } = document;
    const resultsContainer = queryFirst('.results');

    // Find Stores
    bindGA(body, (bindElement, srcElement, e, payload) => {
        const { data } = e;

        return {
            event_category: 'submissions',
            event_action: 'find a store submit',
            event_label: data.radius
        };
    }, {
        eventType: 'storelocator:search'
    });

    // Filters
    bindGA(queryAll('.filter-container'), (bindElement, srcElement) => ({
        // GA4
        event_name: STORE_INTERACTION,
        interaction_type: srcElement.textContent.trim(),
        // GA360
        event_category: STORE_SELECTIONS,
        event_action: srcElement.textContent.trim(),
        event_label: FIND_A_STORE
    }), {
        bindOptions: {
            targetSelectors: ['.form-check-label']
        }
    });

    // Store Details
    bindGA(resultsContainer, (bindElement, srcElement) => {
        const details = srcElement.closest('.store-details');

        return {
            event_category: STORE_SELECTIONS,
            event_action: 'store details',
            event_label: [srcElement.dataset.name, details && details.dataset.storeId]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.explore-store a']
        }
    });

    // Get Directions
    bindGA(resultsContainer, (bindElement, srcElement) => {
        const details = srcElement.closest('.store-details');

        return {
            event_category: STORE_SELECTIONS,
            event_action: GET_DIRECTIONS,
            event_label: [srcElement.dataset.name, details && details.dataset.storeId]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.get-directions-btn']
        }
    });

    // Set Preferred Store
    bindGA(resultsContainer, (bindElement, srcElement) => {
        const detailsLink = queryFirst('.explore-store a', srcElement.closest('.store-details'));

        return {
            event_category: STORE_SELECTIONS,
            event_action: 'set preferred store',
            event_label: [detailsLink && detailsLink.dataset.name, srcElement.dataset.storeId]
        };
    }, {
        bindOptions: {
            targetSelectors: ['.set-preferred-store a']
        }
    });

    // Store Locator
    bindGA(body, (bindElement, srcElement) => {
        const { phoneNumber, storeDetail, searchStore } = srcElement.dataset;
        const mapDetails = getText(srcElement.parentNode).replace(/:/g, '');
        const inMapInteraction = mapDetails ? 'map details - ' + mapDetails : '';

        // GA4
        return {
            event_name: STORE_INTERACTION,
            interaction_type: phoneNumber || storeDetail || searchStore || inMapInteraction
        };
    }, {
        retriggerEvent: false,
        bindOptions: {
            targetSelectors: ['.storelocator-phone', '.store .store-name']
        }
    });
    // Search store submit
    bindGA(body, () => {
        // GA4
        return {
            event_name: STORE_INTERACTION,
            interaction_type: SEARCH_STORE_SUBMISSION
        };
    }, {
        retriggerEvent: false,
        eventType: 'storelocator:search'
    });

    // Store locator on map click
    bindGA(body, () => {
        // GA4
        return {
            event_name: STORE_INTERACTION,
            interaction_type: MAP_CLICK
        };
    }, {
        retriggerEvent: false,
        eventType: 'storelocator:mapClick'
    });
}

initEvents();